module.exports = __webpack_public_path__ + "img/pickens-schools-logo.1fe55264.jpg";